import {
  Box,
  Center,
  Button,
  Heading,
  Tooltip,
  VStack,
  Checkbox,
  Container,
  Image,
  Text,
  SliderTrack,
  SliderFilledTrack,
  Slider,
  SliderThumb,
  SimpleGrid,
  Stack,
} from "@chakra-ui/react";
import { merge, tap } from "rxjs";

import { useEffect, useState } from "react";
import { MintInfo } from "../core/MintInfo";
import Web3Service, { UltimateMutantType } from "../core/web3.service";
import { HStack } from "@chakra-ui/react";

import BackgroundImage from "../images/background-image.webp";
import SampleImage from "../images/sample.gif";
import NFTMintItemView from "./NFTMintItemView";
import { MUTANTS_ADDRESS } from "../config";
import { filterDoctors } from "../core/MutantsHelper";

const MintView: React.FC = () => {
  const web3Service = Web3Service.shared();

  // const [sliderValue, setSliderValue] = useState(1)
  const [showTooltip, setShowTooltip] = useState(false);
  const [useHigherGas, setUseHigherGas] = useState(true);
  const [showGasTooltip, setShowGasTooltip] = useState(false);

  const [account, setAccount] = useState<string | undefined>(undefined);
  const [mintInfo, setMintInfo] = useState<MintInfo | undefined>(undefined);

  const [tokens, setTokens] = useState<number[]>([]);
  const [selectedTokens1, setSelectedTokens1] = useState<number[]>([]);
  const [selectedTokens2, setSelectedTokens2] = useState<number[]>([]);
  const [selectedTokens3, setSelectedTokens3] = useState<number[]>([]);
  const [selectedTokens4, setSelectedTokens4] = useState<number[]>([]);
  const [approved, setIsApproved] = useState(false);
  const [hasPass, setHasPass] = useState(false);

  useEffect(() => {
    web3Service.getMintInfo();
    web3Service.getUserTokens(MUTANTS_ADDRESS);
    web3Service.isApproved();

    const account$ = web3Service.account$.pipe(
      tap((account) => {
        setAccount(account);
      })
    );

    const mintInfo$ = web3Service.mintInfo$.pipe(
      tap((mintInfo) => {
        setMintInfo(mintInfo);
      })
    );

    const tokens$ = web3Service.tokens$.pipe(
      tap((tokens) => {
        setTokens(tokens);
        setSelectedTokens1([]);
        setSelectedTokens2([]);
        setSelectedTokens3([]);
        setSelectedTokens4([]);
      })
    );

    const isApproved$ = web3Service.isApproved$.pipe(
      tap((isApproved) => {
        setIsApproved(isApproved);
      })
    );

    const hasPass$ = web3Service.hasPass$.pipe(
      tap((hasPass) => {
        setHasPass(hasPass);
      })
    );

    const subscription = merge(
      mintInfo$,
      account$,
      tokens$,
      isApproved$,
      hasPass$
    ).subscribe();

    return () => {
      subscription.unsubscribe();
    };
  }, [account]);

  let filteredMutants = filterDoctors(tokens);

  var buttonEnabled: boolean[] = [false, false, false, false];
  var buttonTitle: string[] = ["Loading", "Loading", "Loading", "Loading"];

  let startInfo;

  if (mintInfo) {
    const publicDate = new Date(Number(mintInfo.publicTimestamp) * 1000);

    startInfo = (
      <>
        <VStack mb={8}>
          <VStack textAlign={"center"}>
            <Text>Choose 2 mutants to burn</Text>

            <Text fontWeight={700}>
              Fusion Tool is available If the wallet hold Daolist Pass
            </Text>
          </VStack>
          <Text pt={8} fontSize={"xl"}>
            <b>
              {publicDate.toLocaleString(undefined, {
                dateStyle: "short",
                timeStyle: "short",
              })}
            </b>
          </Text>
        </VStack>
      </>
    );

    const now = new Date();
    let isPaused = mintInfo.isPaused;

    if (isPaused || publicDate > now) {
      buttonTitle[0] = "Coming Soon";
      buttonTitle[1] = "Coming Soon";
      buttonTitle[2] = "Coming Soon";
      buttonTitle[3] = "Coming Soon";
    } else {
      if (Number(35) > Number(mintInfo.cyborgsSupply)) {
        buttonTitle[0] = approved ? "Mint" : "Approve";
        buttonEnabled[0] = !approved || selectedTokens1.length == 2;
      } else {
        buttonTitle[0] = "Sold Out";
      }

      if (Number(60) > Number(mintInfo.aliensSupply)) {
        buttonTitle[1] = approved ? "Mint" : "Approve";
        buttonEnabled[1] = !approved || selectedTokens2.length == 2;
      } else {
        buttonTitle[1] = "Sold Out";
      }

      if (Number(60) > Number(mintInfo.ghostsSupply)) {
        buttonTitle[2] = approved ? "Mint" : "Approve";
        buttonEnabled[2] = !approved || selectedTokens3.length == 2;
      } else {
        buttonTitle[2] = "Sold Out";
      }

      if (Number(400) > Number(mintInfo.zombiesSupply)) {
        buttonTitle[3] = approved ? "Mint" : "Approve";
        buttonEnabled[3] = !approved || selectedTokens4.length == 2;
      } else {
        buttonTitle[3] = "Sold Out";
      }
    }
  }

  let mintedStatsView = (
    <>
      <Center>
        <VStack>
          <Heading fontSize={"2xl"}>Price:</Heading>
          <VStack>
            <Text>
              2 mutants + <b>75 CRO</b>
            </Text>
          </VStack>
          <VStack>
            <Heading pt={4} fontSize={"xl"}>
              Cyborgs {Number(mintInfo?.cyborgsSupply ?? 0)}/{35} minted
            </Heading>
            <Heading pt={4} fontSize={"xl"}>
              Aliens {Number(mintInfo?.aliensSupply ?? 0)}/{60} minted
            </Heading>
            <Heading pt={4} fontSize={"xl"}>
              Ghosts {Number(mintInfo?.ghostsSupply ?? 0)}/{60} minted
            </Heading>
            <Heading pt={4} fontSize={"xl"}>
              Zombies {Number(mintInfo?.zombiesSupply ?? 0)}/{400} minted
            </Heading>
          </VStack>
        </VStack>
      </Center>
    </>
  );

  let gasCheckbox = (
    <>
      <Center mt={8}>
        <Tooltip
          hasArrow
          bg="blue.500"
          color="white"
          placement="top"
          isOpen={showGasTooltip}
          label={
            "Increases the estimated gas cost to reduce a chance of the mint failure. Non-used gas is returned to you."
          }
        >
          <Checkbox
            hidden={false}
            isChecked={useHigherGas}
            onChange={() => setUseHigherGas(!useHigherGas)}
            colorScheme="blue"
            onMouseEnter={() => setShowGasTooltip(true)}
            onMouseLeave={() => setShowGasTooltip(false)}
          >
            Use higher gas estimation
          </Checkbox>
        </Tooltip>
      </Center>
    </>
  );

  let connectButton = (
    <>
      <Center mt={8}>
        <Button
          size={"lg"}
          bgGradient="linear(to-b, rgb(86, 170, 204) 0%, rgb(23, 21, 21) 40%)"
          _hover={{
            bgGradient:
              "linear(to-b, rgb(86, 170, 204) 0%, rgb(23, 21, 21) 75%)",
          }}
          onClick={web3Service.toggleConnect}
        >
          Connect Wallet
        </Button>
      </Center>
    </>
  );

  return (
    <>
      <Box
        position={"fixed"}
        backgroundImage={`url(${BackgroundImage})`}
        backgroundSize="cover"
        width={"100%"}
        height={"100%"}
        opacity={0.5}
        zIndex={-3}
      />

      <Container centerContent maxWidth={1280}>
        <HStack>
          <Box textColor="white" maxWidth={640}>
            <Center>
              <Box maxWidth={480}>
                <Box textAlign={"center"}>
                  <Text
                    fontSize={"3xl"}
                    mt={8}
                    mb={16}
                    px={6}
                    borderRadius={24}
                    bgColor="black"
                  >
                    Mint <b>Ultimate Mutants</b>
                  </Text>
                </Box>
              </Box>
            </Center>

            <Center mt={4}>
              <Image
                borderRadius={"lg"}
                boxShadow={"md"}
                border="3px solid white"
                w={{ base: "128px", md: "256px" }}
                src={SampleImage}
              />
            </Center>

            {account ? (
              <>
                <Box paddingTop={8} position={"relative"}>
                  {startInfo}
                  {mintedStatsView}
                  {buttonEnabled ? gasCheckbox : undefined}

                  {hasPass ? (
                    <Center>
                      <Stack mt={8} direction={["column", "row"]}>
                        <Button
                          onClick={() =>
                            approved
                              ? web3Service.mint(
                                  selectedTokens1,
                                  UltimateMutantType.CYBORGS,
                                  useHigherGas
                                )
                              : web3Service.approveForAll()
                          }
                          isDisabled={!buttonEnabled[0]}
                          size={"lg"}
                          bgGradient="linear(to-b, rgb(86, 170, 204) 0%, rgb(23, 21, 21) 40%)"
                          _disabled={{
                            bgGradient:
                              "linear(to-b, rgb(200, 200, 200) 0%, rgb(120, 120, 120) 75%)",
                          }}
                          _hover={{
                            bgGradient:
                              "linear(to-b, rgb(86, 170, 204) 0%, rgb(23, 21, 21) 75%)",
                          }}
                        >
                          {buttonTitle[0] + " Cyborg"}
                        </Button>

                        <Button
                          onClick={() =>
                            approved
                              ? web3Service.mint(
                                  selectedTokens2,
                                  UltimateMutantType.ALIENS,
                                  useHigherGas
                                )
                              : web3Service.approveForAll()
                          }
                          isDisabled={!buttonEnabled[1]}
                          size={"lg"}
                          bgGradient="linear(to-b, rgb(86, 170, 204) 0%, rgb(23, 21, 21) 40%)"
                          _disabled={{
                            bgGradient:
                              "linear(to-b, rgb(200, 200, 200) 0%, rgb(120, 120, 120) 75%)",
                          }}
                          _hover={{
                            bgGradient:
                              "linear(to-b, rgb(86, 170, 204) 0%, rgb(23, 21, 21) 75%)",
                          }}
                        >
                          {buttonTitle[1] + " Alien"}
                        </Button>

                        <Button
                          onClick={() =>
                            approved
                              ? web3Service.mint(
                                  selectedTokens3,
                                  UltimateMutantType.GHOSTS,
                                  useHigherGas
                                )
                              : web3Service.approveForAll()
                          }
                          isDisabled={!buttonEnabled[2]}
                          size={"lg"}
                          bgGradient="linear(to-b, rgb(86, 170, 204) 0%, rgb(23, 21, 21) 40%)"
                          _disabled={{
                            bgGradient:
                              "linear(to-b, rgb(200, 200, 200) 0%, rgb(120, 120, 120) 75%)",
                          }}
                          _hover={{
                            bgGradient:
                              "linear(to-b, rgb(86, 170, 204) 0%, rgb(23, 21, 21) 75%)",
                          }}
                        >
                          {buttonTitle[2] + " Ghost"}
                        </Button>

                        <Button
                          onClick={() =>
                            approved
                              ? web3Service.mint(
                                  selectedTokens4,
                                  UltimateMutantType.ZOMBIES,
                                  useHigherGas
                                )
                              : web3Service.approveForAll()
                          }
                          isDisabled={!buttonEnabled[3]}
                          size={"lg"}
                          bgGradient="linear(to-b, rgb(86, 170, 204) 0%, rgb(23, 21, 21) 40%)"
                          _disabled={{
                            bgGradient:
                              "linear(to-b, rgb(200, 200, 200) 0%, rgb(120, 120, 120) 75%)",
                          }}
                          _hover={{
                            bgGradient:
                              "linear(to-b, rgb(86, 170, 204) 0%, rgb(23, 21, 21) 75%)",
                          }}
                        >
                          {buttonTitle[3] + " Zombie"}
                        </Button>
                      </Stack>
                    </Center>
                  ) : (
                    <Heading mt={8} textColor={"red.500"} textAlign={"center"}>
                      DaoPass 2D required
                    </Heading>
                  )}

                  {account && (
                    <Center mt={8}>
                      <VStack spacing={0}>
                        <Text fontSize={"lg"} fontWeight={400}>
                          Selected To Burn
                        </Text>
                        <Text
                          fontSize={"lg"}
                          fontWeight={700}
                          textColor="yellow.500"
                        >
                          Cyborgs {selectedTokens1.length} / 2
                        </Text>
                        <Text
                          fontSize={"lg"}
                          fontWeight={700}
                          textColor="green.500"
                        >
                          Aliens {selectedTokens2.length} / 2
                        </Text>
                        <Text
                          fontSize={"lg"}
                          fontWeight={700}
                          textColor="blue.500"
                        >
                          Ghosts {selectedTokens3.length} / 2
                        </Text>
                        <Text
                          fontSize={"lg"}
                          fontWeight={700}
                          textColor="red.500"
                        >
                          Zombies {selectedTokens4.length} / 2
                        </Text>
                      </VStack>
                    </Center>
                  )}

                  {account && (
                    <VStack mt={8}>
                      <Text fontWeight={700} textAlign={"center"}>
                        Cyborgs
                      </Text>
                      {filteredMutants.aliens.length == 0 ? (
                        <Text>No Cyborgs available</Text>
                      ) : undefined}
                      <SimpleGrid
                        columns={{ base: 4, md: 4 }}
                        spacing={{ base: 4, md: 8 }}
                        my={{ base: 4, md: 8 }}
                        mx={"auto"}
                        maxW={"2xl"}
                      >
                        {filteredMutants.cyborgs.map((token, i) => (
                          <VStack
                            key={i}
                            spacing={2}
                            onClick={() => {
                              var copy = selectedTokens1;
                              if (selectedTokens1.some((id) => id === token)) {
                                const index = copy.indexOf(token, 0);
                                if (index > -1) {
                                  copy.splice(index, 1);
                                }
                              } else if (copy.length < 2) {
                                copy.push(token);
                              }
                              setSelectedTokens1([...copy]);
                            }}
                          >
                            <NFTMintItemView
                              name={`#${token}`}
                              image={`https://bafybeiglssbennap6cz4jxc2nhsbymxbd635p4zgt7kixou54dtgeor7ca.ipfs.nftstorage.link/${token}.png`}
                              selected={selectedTokens1.some(
                                (t) => t === token
                              )}
                            />
                          </VStack>
                        ))}
                      </SimpleGrid>
                    </VStack>
                  )}

                  {account && (
                    <VStack mt={8}>
                      <Text fontWeight={700} textAlign={"center"}>
                        Aliens
                      </Text>
                      {filteredMutants.aliens.length == 0 ? (
                        <Text>No Aliens available</Text>
                      ) : undefined}
                      <SimpleGrid
                        columns={{ base: 4, md: 4 }}
                        spacing={{ base: 4, md: 8 }}
                        my={{ base: 4, md: 8 }}
                        mx={"auto"}
                        maxW={"2xl"}
                      >
                        {filteredMutants.aliens.map((token, i) => (
                          <VStack
                            key={i}
                            spacing={2}
                            onClick={() => {
                              var copy = selectedTokens2;
                              if (selectedTokens2.some((id) => id === token)) {
                                const index = copy.indexOf(token, 0);
                                if (index > -1) {
                                  copy.splice(index, 1);
                                }
                              } else if (copy.length < 2) {
                                copy.push(token);
                              }
                              setSelectedTokens2([...copy]);
                            }}
                          >
                            <NFTMintItemView
                              name={`#${token}`}
                              image={`https://bafybeiglssbennap6cz4jxc2nhsbymxbd635p4zgt7kixou54dtgeor7ca.ipfs.nftstorage.link/${token}.png`}
                              selected={selectedTokens2.some(
                                (t) => t === token
                              )}
                            />
                          </VStack>
                        ))}
                      </SimpleGrid>
                    </VStack>
                  )}

                  {account && (
                    <VStack mt={8}>
                      <Text fontWeight={700} textAlign={"center"}>
                        Ghosts
                      </Text>
                      {filteredMutants.aliens.length == 0 ? (
                        <Text>No Ghosts available</Text>
                      ) : undefined}
                      <SimpleGrid
                        columns={{ base: 4, md: 4 }}
                        spacing={{ base: 4, md: 8 }}
                        my={{ base: 4, md: 8 }}
                        mx={"auto"}
                        maxW={"2xl"}
                      >
                        {filteredMutants.ghosts.map((token, i) => (
                          <VStack
                            key={i}
                            spacing={2}
                            onClick={() => {
                              var copy = selectedTokens3;
                              if (selectedTokens3.some((id) => id === token)) {
                                const index = copy.indexOf(token, 0);
                                if (index > -1) {
                                  copy.splice(index, 1);
                                }
                              } else if (copy.length < 2) {
                                copy.push(token);
                              }
                              setSelectedTokens3([...copy]);
                            }}
                          >
                            <NFTMintItemView
                              name={`#${token}`}
                              image={`https://bafybeiglssbennap6cz4jxc2nhsbymxbd635p4zgt7kixou54dtgeor7ca.ipfs.nftstorage.link/${token}.png`}
                              selected={selectedTokens3.some(
                                (t) => t === token
                              )}
                            />
                          </VStack>
                        ))}
                      </SimpleGrid>
                    </VStack>
                  )}

                  {account && (
                    <VStack mt={8}>
                      <Text fontWeight={700} textAlign={"center"}>
                        Zombies
                      </Text>
                      {filteredMutants.aliens.length == 0 ? (
                        <Text>No Zombies available</Text>
                      ) : undefined}
                      <SimpleGrid
                        columns={{ base: 4, md: 4 }}
                        spacing={{ base: 4, md: 8 }}
                        my={{ base: 4, md: 8 }}
                        mx={"auto"}
                        maxW={"2xl"}
                      >
                        {filteredMutants.zombies.map((token, i) => (
                          <VStack
                            key={i}
                            spacing={2}
                            onClick={() => {
                              var copy = selectedTokens4;
                              if (selectedTokens4.some((id) => id === token)) {
                                const index = copy.indexOf(token, 0);
                                if (index > -1) {
                                  copy.splice(index, 1);
                                }
                              } else if (copy.length < 2) {
                                copy.push(token);
                              }
                              setSelectedTokens4([...copy]);
                            }}
                          >
                            <NFTMintItemView
                              name={`#${token}`}
                              image={`https://bafybeiglssbennap6cz4jxc2nhsbymxbd635p4zgt7kixou54dtgeor7ca.ipfs.nftstorage.link/${token}.png`}
                              selected={selectedTokens4.some(
                                (t) => t === token
                              )}
                            />
                          </VStack>
                        ))}
                      </SimpleGrid>
                    </VStack>
                  )}
                </Box>
              </>
            ) : (
              connectButton
            )}
          </Box>
        </HStack>
      </Container>
    </>
  );
};

export default MintView;
